export const LD_ENV_KEYS = {
  prod: '58458145f0b82e090f3cd4b7',
  uat: '58458145f0b82e090f3cd4b6',
  dev: '5845820b06d0860905489217',
};
